import { useState, useEffect } from 'react';
import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const STYLES = {
  info:    { bg: '#1B3A5C', color: '#fff',    icon: 'ti-info-circle' },
  success: { bg: '#16a34a', color: '#fff',    icon: 'ti-circle-check' },
  warning: { bg: '#854F0B', color: '#fff',    icon: 'ti-alert-triangle' },
  error:   { bg: '#C1272D', color: '#fff',    icon: 'ti-alert-circle' },
};

export default function AnnouncementBanner() {
  const [banner,    setBanner]    = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const key = 'ip_announcement_dismissed';
    axios.get(`${BASE}/system/announcement`).then(({ data }) => {
      if (!data.active) return;
      // Don't re-show a banner the user already dismissed in this session
      const stored = sessionStorage.getItem(key);
      if (stored === data.text) { setDismissed(true); return; }
      setBanner(data);
    }).catch(() => {});
  }, []);

  if (!banner || dismissed) return null;

  const style = STYLES[banner.type] || STYLES.info;

  const dismiss = () => {
    sessionStorage.setItem('ip_announcement_dismissed', banner.text);
    setDismissed(true);
  };

  return (
    <div style={{ background: style.bg, color: style.color, padding: '10px 20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, fontSize: 13, position: 'relative', zIndex: 100 }}>
      <i className={`ti ${style.icon}`} style={{ fontSize: 16, flexShrink: 0 }} />
      <span style={{ fontWeight: 500 }}>{banner.text}</span>
      <button onClick={dismiss} aria-label="Dismiss" style={{ background: 'none', border: 'none', color: 'inherit', opacity: 0.6, cursor: 'pointer', padding: '2px 6px', display: 'flex', alignItems: 'center', marginLeft: 8, flexShrink: 0 }}>
        <i className="ti ti-x" style={{ fontSize: 16 }} />
      </button>
    </div>
  );
}
